export type PrincipalType = (typeof PrincipalType)[keyof typeof PrincipalType];

export const PrincipalType = {
    User: 'User',
    Group: 'Group',
    Client: 'Client',
    Tenant: 'Tenant',
} as const;
